export default __webpack_public_path__ + "static/media/Save.c2425514.svg";